import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
// Required for MUI v5 Date Pickers used by JSON Forms
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import FormPage from './Pages/FormPage';
import TestPage from './Pages/TestPage';
import FormsListPage from './Pages/FormsListPage';
import FormDetailsPage from './Pages/FormDetailsPage';
import ThemesListPage from './Pages/ThemesListPage';
import ThemeDetailsPage from './Pages/ThemeDetailsPage';
import LanguagesListPage from './Pages/LanguagesListPage';
import LanguageDetailsPage from './Pages/LanguageDetailsPage';
function App() {
  return (
    <Router>
      <div className="App">
        <Suspense fallback={<div style={{ padding: '2em' }}>Loading translations...</div>}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Routes>
              <Route path="/" element={<FormPage />} />
              <Route path="/forms" element={<FormsListPage />} />
              <Route path="/forms/:uuid" element={<FormDetailsPage />} />
              <Route path="/themes" element={<ThemesListPage />} />
              <Route path="/themes/:uuid" element={<ThemeDetailsPage />} />
              <Route path="/languages" element={<LanguagesListPage />} />
              <Route path="/languages/:uuid" element={<LanguageDetailsPage />} />
              <Route path="/test" element={<TestPage />} />
            </Routes>
          </LocalizationProvider>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
